package com.patronat.top.library.media.data.mappers

import com.patronat.top.dto.FileRegistrationResponse
import com.patronat.top.library.media.domain.models.FileRegistration

fun FileRegistrationResponse.toDomain(): FileRegistration{
    return FileRegistration(
        publicUrl = this.publicUrl,
        mediaId = this.mediaId,
    )
}